import {
  Building2,
  MapPin,
  Link as LinkIcon,
  Twitter,
  Github,
  Globe,
  Mail,
  Phone,
  Briefcase,
  UserRound,
  BadgeInfo,
  CircleHelp,
  Facebook,
  Instagram,
  Youtube,
  MessageCircle,
} from 'lucide-react';

export const PROFILE_ICON_OPTIONS = [
  { value: 'building2', label: 'Building', icon: Building2 },
  { value: 'map-pin', label: 'Map Pin', icon: MapPin },
  { value: 'link', label: 'Link', icon: LinkIcon },
  { value: 'twitter', label: 'Twitter / X', icon: Twitter },
  { value: 'github', label: 'GitHub', icon: Github },
  { value: 'globe', label: 'Globe', icon: Globe },
  { value: 'mail', label: 'Mail', icon: Mail },
  { value: 'phone', label: 'Phone', icon: Phone },
  { value: 'briefcase', label: 'Briefcase', icon: Briefcase },
  { value: 'user-round', label: 'User', icon: UserRound },
  { value: 'badge-info', label: 'Info', icon: BadgeInfo },
  { value: 'facebook', label: 'Facebook', icon: Facebook },
  { value: 'instagram', label: 'Instagram', icon: Instagram },
  { value: 'youtube', label: 'YouTube', icon: Youtube },
  { value: 'message-circle', label: 'Message Circle', icon: MessageCircle },
  { value: 'circle-help', label: 'Default', icon: CircleHelp },
];

export const profileIconMap = PROFILE_ICON_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item.icon;
  return acc;
}, {});
